// Use environment variable for API host with fallback
const HOST = import.meta.env.VITE_API_BASE_URL || "https://mailapi.elsaj.in";
// const HOST = "http://localhost:5000" // Development fallback

const BASE_URL = `${HOST}/api/v1`;

const URL = {
  email: `/emails`,
  emailTemplates: `/email-templates`,
};
const CONSTANTS = {
  HOST,
  BASE_URL,
  URL,
};

export default CONSTANTS;
